import asyncComponent from './asyncComponent';
/**
 * Responsible for code splitting for performance
 * Use with <Route getComponent /> signature
 */

// privacy policy is a lot of static HTML we should keep out of the main build
// export function PrivacyPolicyPage(nextState, cb) {
//   require.ensure([], (require) => {
//     cb(null, require('./components/PrivacyPolicyPage').default);
//   });
// }
// // ditto terms
// export function TermsPage(nextState, cb) {
//   require.ensure([], (require) => {
//     cb(null, require('./components/TermsPage').default);
//   });
// }
// // and DMCA
// export function DMCAPage(nextState, cb) {
//   require.ensure([], (require) => {
//     cb(null, require('./components/DMCAPage').default);
//   });
// }

// dependency on moment (rather big)
export const ArchiveContainer = asyncComponent('ArchiveContainer', () =>
  import(/* webpackChunkName: "ArchiveContainer" */ './components/ArchiveContainer').then(
    m => m.default
  )
);

export const AuthRouter = asyncComponent('AuthRouter', () =>
  import(/* webpackChunkName: "AuthRouter" */ './components/AuthRouter').then(
    m => m.default
  )
);

export const EpisodeEditorPublishContainer = asyncComponent(
  'EpisodeEditorPublishContainer',
  () =>
    import(/* webpackChunkName: "EpisodeEditorPublishContainer" */ './components/EpisodeEditorPublishContainer').then(
      m => m.default
    )
);

export const EpisodeMetadataEditorContainer = asyncComponent(
  'EpisodeMetadataEditorContainer',
  () =>
    import(/* webpackChunkName: "EpisodeMetadataEditorContainer" */ './components/EpisodeMetadataEditorContainer').then(
      m => m.default
    )
);

export const EpisodeEmbedContainer = asyncComponent(
  'EpisodeEmbedContainer',
  () =>
    import(/* webpackChunkName: "EpisodeEmbedContainer" */ './components/EpisodeEmbedContainer').then(
      m => m.default
    )
);

export const EpisodePlayerContainer = asyncComponent(
  'EpisodePlayerContainer',
  () =>
    import(/* webpackChunkName: "EpisodePlayerContainer" */ './components/EpisodePlayerContainer').then(
      m => m.default
    )
);

// dependency on moment (rather big)
export const PartnerAnalyticsContainer = asyncComponent(
  'PartnerAnalyticsContainer',
  () =>
    import(/* webpackChunkName: "PartnerAnalyticsContainer" */ './components/PartnerAnalyticsContainer').then(
      m => m.default
    )
);

// dependency on moment (rather big)
export const PartnerEpisodeContainer = asyncComponent(
  'PartnerEpisodeContainer',
  () =>
    import(/* webpackChunkName: "PartnerEpisodeContainer" */ './components/PartnerEpisodeContainer').then(
      m => m.default
    )
);

// dependency on moment (rather big)
export const PartnerEpisodesContainer = asyncComponent(
  'PartnerEpisodesContainer',
  () =>
    import(/* webpackChunkName: "PartnerEpisodesContainer" */ './components/PartnerEpisodesContainer').then(
      m => m.default
    )
);

export const ProfileContainer = asyncComponent('ProfileContainer', () =>
  import(/* webpackChunkName: "ProfileContainer" */ './components/ProfileContainer').then(
    m => m.default
  )
);

export const ProfileEpisodeContainer = asyncComponent(
  'ProfileEpisodeContainer',
  () =>
    import(/* webpackChunkName: "ProfileEpisodeContainer" */ './components/ProfileEpisodeContainer').then(
      m => m.default
    )
);

export const StationEmbedContainer = asyncComponent(
  'StationEmbedContainer',
  () =>
    import(/* webpackChunkName: "StationEmbedContainer" */ './components/StationEmbedContainer').then(
      m => m.default
    )
);

// // AMP routes

// export const asyncComponentWrapper = (containerName) => {
//   const component = asyncComponent(containerName, () => {
//     return new Promise((resolve, reject) => {
//       require.ensure([], (require) => {
//         // need to require index.js afterwards for some reason
//         resolve(require(`./components/${containerName}/index.js`).default);
//       });
//     })
//   });
//   return component;
// }
